module.exports = __webpack_public_path__ + "img/presencial-linea.5a7e5ba6.svg";